import { CheckboxesWidget } from './checkboxesWidget';
import { CheckboxWidget } from './checkboxWidget';
import { CodeEditorReaderWidget } from './codeEditorWidget';
import { DateWidget } from './dateWidget';
import { GroupWidget } from './groupWidget/groupWidget.reader';
import { NumericWidget } from './numeric/numericWidget';
import { Radio } from './radioWidget/radio';
import { SlateReaderWidget } from './slateReaderWidget';
import { TextWidget } from './textWidget';

export const readerWidgets: {
  [componentName: string]: React.FC<any>;
} = {
  TextWidget,
  NumericWidget,
  CheckboxWidget,
  CheckboxesWidget,
  CodeEditorWidget: CodeEditorReaderWidget,
  draft: SlateReaderWidget,
  TextareaWidget: TextWidget,
  SelectWidget: TextWidget,
  RadioWidget: Radio,
  'alt-date': DateWidget,
  'workflow-group': GroupWidget,
  MultiSelectWidget: CheckboxesWidget
};
